// extracted by mini-css-extract-plugin
export default {"faqs":"QB-z","faqContent":"RB-z","faq":"SB-z"};